// ==================== OPTIMIZED ADD TO CART HANDLER ====================
// This handles all "Add to Cart" button clicks with instant feedback
// Place this in your theme after cart-state-manager-optimized.js

(function() {
  'use strict';
  
  // Handle all Add to Cart button clicks
  document.addEventListener('DOMContentLoaded', function() {
    
    // Delegate event handling for better performance
    document.body.addEventListener('click', function(e) {
      const addToCartBtn = e.target.closest('.add-to-cart-btn, .add-to-cart-btn-grid, [data-add-to-cart]');
      
      if (addToCartBtn) {
        e.preventDefault();
        e.stopPropagation();
        handleAddToCart(addToCartBtn);
      }
    });
    
    // Also handle quantity increment/decrement buttons
    document.body.addEventListener('click', function(e) {
      const incrementBtn = e.target.closest('.quantity-increment, .quantity-plus');
      const decrementBtn = e.target.closest('.quantity-decrement, .quantity-minus');
      
      if (incrementBtn) {
        e.preventDefault();
        handleQuantityChange(incrementBtn, 1);
      } else if (decrementBtn) {
        e.preventDefault();
        handleQuantityChange(decrementBtn, -1);
      }
    });
  });
  
  // Handle Add to Cart
  function handleAddToCart(button) {
    const form = button.closest('form, .product-form, .product-form-grid');
    if (!form) return;
    
    // Get variant ID
    const variantSelect = form.querySelector('.product-variant-select, .variant-select, .variant-select-grid');
    const hiddenInput = form.querySelector('input[name="id"]');
    const variantId = variantSelect ? variantSelect.value : (hiddenInput ? hiddenInput.value : null);
    
    if (!variantId) {
      alert('Please select a variant');
      return;
    }
    
    // Get quantity
    const quantityInput = form.querySelector('.quantity-input, input[name="quantity"]');
    const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
    
    // Disable button to prevent double-clicks
    const originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding...';
    
    // OPTIMISTIC UPDATE: Dispatch event immediately for instant UI update
    document.dispatchEvent(new CustomEvent('cart:item-added', {
      detail: {
        variant_id: variantId,
        quantity: quantity
      }
    }));
    
    // Prepare form data
    const formData = {
      items: [{
        id: variantId,
        quantity: quantity
      }]
    };
    
    // Send request to Shopify
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(data => {
      // Success feedback
      button.textContent = '✓ Added';
      setTimeout(() => {
        button.disabled = false;
        button.textContent = originalText;
      }, 1000);
      
      // Refresh cart state to ensure accuracy
      if (window.CartStateManager) {
        window.CartStateManager.refreshCartState();
      }
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
      button.textContent = 'Error';
      button.disabled = false;
      
      // Revert optimistic update by refreshing
      if (window.CartStateManager) {
        window.CartStateManager.refreshCartState();
      }
      
      alert('Error adding item to cart. Please try again.');
    });
  }
  
  // Handle quantity change (increment/decrement)
  function handleQuantityChange(button, delta) {
    const form = button.closest('form, .product-form, .product-form-grid, .quantity-selector, .quantity-selector-grid');
    if (!form) return;
    
    // Get variant ID
    const variantSelect = form.querySelector('.product-variant-select, .variant-select, .variant-select-grid');
    const hiddenInput = form.querySelector('input[name="id"]');
    const variantId = variantSelect ? variantSelect.value : (hiddenInput ? hiddenInput.value : null);
    
    if (!variantId) return;
    
    // Get current quantity from display
    const quantityDisplay = form.querySelector('.quantity-display, .quantity-display-grid');
    const currentQuantity = quantityDisplay ? parseInt(quantityDisplay.textContent) || 0 : 0;
    const newQuantity = Math.max(0, currentQuantity + delta);
    
    // OPTIMISTIC UPDATE: Update display immediately
    if (quantityDisplay) {
      quantityDisplay.textContent = newQuantity;
    }
    
    // Dispatch event for cart icon update
    document.dispatchEvent(new CustomEvent('cart:item-updated', {
      detail: {
        variant_id: variantId,
        quantity: newQuantity,
        delta: delta
      }
    }));
    
    // Update cart on server
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: variantId,
        quantity: newQuantity
      })
    })
    .then(response => response.json())
    .then(data => {
      // Refresh cart state to ensure everything is in sync
      if (window.CartStateManager) {
        window.CartStateManager.debouncedRefresh();
      }
    })
    .catch(error => {
      console.error('Error updating cart:', error);
      
      // Revert optimistic update
      if (window.CartStateManager) {
        window.CartStateManager.refreshCartState();
      }
    });
  }
})();
